import React, { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export function formatForLabel(header: string, body: ReactNode = null) {
  return (
    <Container>
      <small>{header}</small>
      {body}
    </Container>
  )
}
